// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"254a667ca311385b8019","777":"71daf53ecb0afa88a219"}[chunkId] + ".bundle.js";
};